import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Left, Right, wrapperAktualne } from './Symbols/WidgetLayout';
import Head2Head from './Components/Head2HeadWidget';
import { ResultTitle, Header, Totals } from './Components/Head2HeadWidget/styles';
import { Button } from './Components/InterestingDistricts/styles';
import { sortBy } from './Utils/Sorters'
import { getHasElectionFinished, getRoundLeaders } from './Utils/Getters';
import InfoPanel from './Components/InfoPanel/SenateWidget';
import Summary from './Components/WidgetSummary/WidgetSummaryDiagram';
import withDataLoader from './Utils/withDataLoader';
import styled from 'react-emotion';
import WidgetSummaryMap from './Components/WidgetSummary/WidgetSummaryMap';
import WidgetMapOnMobileDevice from './Components/WidgetSummary/WidgetMapOnMobileDevice';

const WrapperSenate = styled(Wrapper)`
	min-height: 240px;
`;

const WrapperSenateLeft = styled(Left)`
	background: #f6f6f6;
	padding: 1rem;
	svg {
		max-height: 170px;
		@media (max-width: 1090px) {
			margin-bottom: 35px;
		}
	}
	@media (max-width: 1090px) {
		position: relative;
	}
	@media (max-width: 759px) {
		display: none;
	}
	@media (min-width: 760px) {
		flex-basis: 45%;
	}
`;

const WrapperSenateRight = styled(Right)`
	padding: 1rem;
	background: #fff;

	@media (max-width: 1023px) {
		display: block;
		width: 100%
	}
	@media (min-width: 760px) {
		position: relative;
		flex-basis: 55%;
	}
	@media (max-width: 480px) {
		padding-left: 0;
		padding-right: 0;
	}
`;

const LinkToFirstRound = styled.div`
	@media (max-width: 1090px) {
		text-align: center;
		width: 100%;
	}
	@media (min-width: 1091px) {
		position: absolute;
		top: 0;
		right: 16px;
	}
`;

const H2Hwrapper = styled.div`
	${ResultTitle} {
		@media (min-width: 760px) {
			display: none;
		}
	}
	
	${Header} {
		width: 100%;
		@media (min-width: 993px) {
			text-align: left;
		}
	}
	
	${Totals} {
		@media (max-width: 480px) {
			display: block;
			margin-top: 4px;
			margin-bottom: 4px;
		}
	}
`;


class App extends React.PureComponent {
	constructor(props) {
		super(props)
		this.update = this.update.bind(this)
	}

	onClick = (id) => {
		window.top.location.href = `${this.props.link}#/obvod/${id}`;
	};

	state = {
		interestingDistricts: [],
		finalists: [],
		elected: [],
		regions: [],
		meta: [],
		leaders: {},
		districts: [],
		parties: []
	};

	componentDidMount() {
		this.load();
	}

	componentDidUpdate() {
		this.update()
	}

	update() {
		if (this.props.onUpdate) {
			this.props.onUpdate();
		}
	}

	load = () => {
		this.props.loadDataAsync([`senate/${this.props.year}/vysledky_souhrn.json`])
			.then(
				([data]) => {
					const finalists = data.body.finalists.sort(sortBy(1, 'votes'));
					this.setState({
						...data.body,
						interestingDistricts: (this.props.interestingDistricts || this.props.districts.slice(0, 3)).map(district => {
							return {
								...(data.body.leaders[0][district] || {}).area,
								names: finalists.filter(finalist => finalist.area.id === district).map(finalist => finalist.lastName)
							};
						}),
						leaders: getRoundLeaders(data.body.leaders, 1, data.body.meta),
						districts: (this.props.interestingDistricts || this.props.districts.slice(0, 3)).map(district => {
							const finalists = data.body.finalists.filter((item) => item.area.id === district).sort(sortBy(1, 'votes'));
							return {
								...(data.body.leaders[0][district] || {}).area,
								names: finalists.map(candidate => candidate.lastName)
							};
						}),
						parties: Object.values(Object.values(data.body.leaders[1]).reduce((parties, leader) => {
							if (!parties[leader.proposingParty.id]) {
								parties[leader.proposingParty.id] = {
									...leader.proposingParty,
									count: 0
								}
							}
							parties[leader.proposingParty.id].count++;
							return parties;
						}, {})).sort((a, b) => b.count - a.count || a.id - b.id).slice(0, 3)
					});
				}).catch(console.error);
	}

	render() {
		const roundIndex = 1;
		const hasElectionFinished = getHasElectionFinished(this.state.meta[1]);
		return (
			<>
				<WrapperSenate className={wrapperAktualne}>
					<WrapperSenateLeft>
						{this.state.meta.length > 0 &&
							<WidgetSummaryMap
								meta={this.state.meta[1]}
								districts={this.props.districts}
								leaders={this.state.leaders}
								link={this.props.linkToSenate}
								parties={this.state.parties}
								logos={this.props.logos}
							/>
						}
					</WrapperSenateLeft>
					<WrapperSenateRight>
						{hasElectionFinished ?
								<>
									{this.state.meta.length > 0 &&
										<Summary
											meta={this.state.meta[1]}
											districts={this.props.districts}
											leaders={this.state.leaders}
											link={this.props.linkToSenate}
											parties={this.state.parties}
											logos={this.props.logos}
										/>
									}
									<WidgetMapOnMobileDevice
										link={this.props.linkToSenate}
										districts={this.props.districts}
										leaders={this.state.leaders}
									/>
								</>
							:
								<>
									<H2Hwrapper>
										{this.state.finalists.length > 0 && <Head2Head
											finalists={this.state.finalists.concat(this.state.elected)}
											faces={this.props.faces}
											roundIndex={roundIndex}
											meta={this.state.meta}
											onUpdate={this.update}
										/>}
									</H2Hwrapper>
									<LinkToFirstRound>
										<Button reverse href={this.props.linkToSenate}>
											Přehled všech obvodů
										</Button>
									</LinkToFirstRound>
								</>
						}
					</WrapperSenateRight>
				</WrapperSenate>
				{!hasElectionFinished &&
					<InfoPanel roundIndex={roundIndex} finalists={this.state.finalists} linkToSenate={this.props.linkToSenate} />
				}
			</>
		)
	}
}

App.propTypes = {
	rootUrl: PropTypes.string.isRequired,
	year: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]).isRequired,
	linkToSenate: PropTypes.string.isRequired,
	interestingDistricts: PropTypes.arrayOf(PropTypes.number),
	faces: PropTypes.object.isRequired,
	onUpdate: PropTypes.func,
	logos: PropTypes.object.isRequired
};

App.defaultProps = {
	linkToSenate: 'senate-2020.html'
}

export default withDataLoader(App);
